import { useQuery } from '@tanstack/react-query';
import { fetchShippingRates } from '../apis/shipping';
import type { ShippingLine } from '../types/shipping.types';

// A quote takes seconds: do not re-quote on every focus, only when the order changes
const RATES_STALE_TIME = 5 * 60 * 1000;

/** Rates for the lines to the address; nothing is requested until both are known. */
export const useShippingRates = (addressId: string | undefined, lines: ShippingLine[]) =>
  useQuery({
    queryKey: ['shipping-rates', addressId, lines],
    queryFn: () => fetchShippingRates({ address_id: addressId as string, lines }),
    enabled: !!addressId && lines.length > 0,
    staleTime: RATES_STALE_TIME,
    refetchOnWindowFocus: false,
  });
